import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IAppConfig } from '@app/store/models/config.interface';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { lastValueFrom, Subscription } from 'rxjs';
import { UserInvitationResponse } from 'shared-library';
import { APP_CONFIG } from 'src/app/modules/core/config/config';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-auth-accept-invitation',
  templateUrl: './auth-accept-invitation.component.html',
  styleUrls: ['./../auth.global.scss', './auth-accept-invitation.component.scss']
})
export class AuthAcceptInvitationComponent implements OnInit, OnDestroy {

  processing = false
  response: UserInvitationResponse = {
    name: "",
    preferred_name: "",
    processing: false,
    accepted: false,
    team_name: "",
    email: "",
    token: ""
  }

  session_info: SessionInfo
  subscriptions: Subscription[] = []
  signupform: FormGroup<_SignUpForm>

  error: string
  token_id: string

  constructor(
    private router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private coreService: CoreService,
    private activatedRoute: ActivatedRoute,
    private functionService: FunctionsService,
    @Inject(APP_CONFIG) public config: IAppConfig,
    private qrGeneratorService: UserQrGeneratorService,
  ) {
    this.token_id = this.activatedRoute.snapshot.queryParams.code
    //Check if activated
    if (!this.token_id) {
      this.router.navigateByUrl("/auth/signin");
      return;
    }
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
  }

  ngOnInit(): void {
    this.checkToken()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe())
  }

  fillFormData() {
    this.signupform = this.formBuilder.group({
      password: ["", [Validators.required]],
      name: [this.response.name, [Validators.required]],
      timezone: [Intl.DateTimeFormat().resolvedOptions().timeZone],
    })
  }

  async checkToken() {
    this.response.processing = true
    try {
      let { data: response } = (await lastValueFrom(this.http.get<{ data: UserInvitationResponse }>(`${this.config.apiEndpoints.auth.signup_by_invitation}${this.token_id}/verify`)))
      if (response.accepted) {
        this.functionService.showSuccessMessage("Invitation accepted")
        this.router.navigateByUrl("/auth/signin")
        return
      }
      this.response = response
      this.fillFormData()
    } catch (error) {
      this.error = error?.error?.error || "Expired invitation link"
    }
    this.response.processing = false
  }

  async joinTeam() {

    this.signupform.markAllAsTouched()
    if (!this.signupform.valid) {
      this.functionService.logToConsole(this.signupform.errors)
      this.qrGeneratorService.scrollToFirstInvalidControl()
      return
    }

    this.processing = true;
    try {
      this.response = (await this.http.post(`${this.config.apiEndpoints.auth.signup_by_invitation}${this.token_id}/signup`, this.signupform.value).toPromise() as any).data
      if (this.response.token) {
        await this.coreService.logMeIn(this.response.token)
        return
      }
      this.router.navigateByUrl("/auth/signin");
    } catch (error) {
      this.error = error?.error?.error || "Expired invitation link"
    }
    this.processing = false;
  }

}

interface _SignUpForm {
  name: FormControl<string>;
  timezone: FormControl<string>;
  password: FormControl<string>;
}
